import React from "react";
import Section from "./Section";

export default function About() {
  return (
    <Section id="about" className="ud-about">
      <div className="ud-about-wrapper wow fadeInUp" data-wow-delay=".2s">
        <div className="ud-about-content-wrapper">
          <div className="ud-about-content">
            <span className="tag">Hakkımızda</span>
            <h2>Aidat+ ile Site ve Apartman Yönetimi Artık Çok Kolay</h2>
            <p>
              Aidat+, site ve apartman yöneticileri için tasarlanmış modern bir
              yönetim platformudur. Aidat takibi, ödemeler, kullanıcı ve daire
              yönetimi tek panelden kontrol edilebilir.
            </p>

            <p>
              Güvenli ve hızlı bir şekilde kullanıcı ekleyebilir, aidatları
              takip edebilir ve raporlar alabilirsiniz. Yönetim artık daha
              şeffaf ve organize.
            </p>

            <a href="#features" className="ud-main-btn">
              Özellikleri Keşfet
            </a>
          </div>
        </div>
        <div className="ud-about-image">
          <img
            src="/assets/images/about/about-image.svg"
            alt="Aidat+ yönetim paneli"
          />
        </div>
      </div>
    </Section>
  );
}
